<template>
  <div>
    <loader :is-loading="loading" color="primary" :full-page="true">
      <v-row>
        <v-col cols="12" md="12" class="flex-container">
          <v-btn class="mr-4" color="primary" @click="showDialog = true" :loading="loading">{{ $t("paymentOnboarding.start") }}</v-btn>
        </v-col>
      </v-row>
    </loader>
    <stripe-conditions-dialog v-model="showDialog" :show-cancel="true" :body-copy="stripeDialogText" @onCancel="navigateToHome" @onAgree="navigateToPaymentOnboarding"></stripe-conditions-dialog>
  </div>
</template>

<script>
import StripeConditionsDialog from '@/components/StripeConditionsDialog';

import { bookingChannelComputed } from '../../mixins/bookingChannel.mixins';
import { selectedFleetId } from '../../mixins/fleets.mixins';

export default {
  name: 'PaymentOnboarding',
  components: { StripeConditionsDialog },
  data() {
    return {
      loading: false,
      showDialog: false,
    };
  },
  mixins: [bookingChannelComputed, selectedFleetId],
  computed: {
    stripeDialogText() {
      return this.$t('components.stripeTermsConditions.continueCopy');
    },
  },
  methods: {
    displayDialog() {
      this.showDialog = true;
    },
    async navigateToPaymentOnboarding() {
      this.loading = true;
      const result = await this.$store.dispatch('paymentOnboarding/init', this.selectedFleetId);
      if (result && result.url) {
        window.location = result.url;
      } else {
        await this.navigateToHome();
      }
    },
    async navigateToHome() {
      await this.$router.push('/captures');
    },
  },
  beforeMount() {
    if (this.fleets && this.multiFleetEnabled) {
      this.showDialog = false;
    } else {
      this.showDialog = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 94px);
}
</style>
